module.exports = __webpack_public_path__ + "static/media/message-circle.4db6cc76.svg";